<script setup lang="ts">
import { useI18n } from "vue-i18n"

import { Avatar } from "@/shared/ui"
import type { WorkingMaster } from "@/entities/booking"

interface Props {
  master: WorkingMaster
  catSlot: number
  isDayOff: boolean
}

defineProps<Props>()
const { t } = useI18n()
</script>

<template>
  <div
    class="master-col-header"
    :data-cat="catSlot"
    :class="{ 'is-day-off': isDayOff }"
  >
    <Avatar
      :name="master.name"
      size="sm"
      :alt="master.name"
    />
    <span class="master-col-header__name">{{ master.name }}</span>
    <span
      v-if="isDayOff"
      class="master-col-header__day-off"
    >{{ t("masters.schedule.dayOff") }}</span>
  </div>
</template>

<style scoped>
.master-col-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 4px 6px;
  min-width: var(--master-col-w, 140px);
  border-right: 1px solid var(--border);
}

.master-col-header.is-day-off { opacity: 0.5; }

.master-col-header__name {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--foreground);
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.master-col-header__day-off {
  font-size: 0.65rem;
  color: var(--muted-foreground);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
</style>
